export { TabsCategory } from './TabsCategory';
